<template>
    <div class="room">
        <slot><!-- Place to insert a "remove" button --></slot>
        <div class="row">
            <div class="column small-6"><label :for="'adults' + idx" class="text-right middle" v-translate>adults</label></div>
            <div class="column small-6"><input :id="'adults' + idx" type="number" min="1" v-model.number="adults" /></div>
        </div>
        <div class="row">
            <div class="column small-6"><label :for="'children' + idx" class="text-right middle" v-translate>children</label></div>
            <div class="column small-6"><input :id="'children' + idx" type="number" min="0" v-model.number="numChildren" /></div>

        </div>
        <div v-if="numChildren > 0" class="childrens-ages row noflex">
            <p v-translate>children-age-label</p>
            <div v-for="(age, n) in children" :key="'child-' + n" class="small-6 columns">
                <label><span v-translate>child</span> {{ n+1 }}
                    <select :id="'age-child' + n" v-model.number="children[n]" >
                        <option v-for="i in 19" :value="i-1">{{ (i-1) }}</option>
                    </select>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Room',
    props: {
        idx: {
            type: Number,
            required: true
        },
        numAdults: {
            type: Number,
            default: 1
        },
        childrenAges: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            numChildren: this.childrenAges.length,
            adults: this.numAdults,
            children: this.childrenAges
        }
    },

    computed : {

    },

    watch: {
        numChildren: function (newVal, oldVal) {
          if (newVal < this.children.length) {
              this.children.splice(newVal, oldVal-newVal)
              return
          }
          if (newVal > this.children.length) {
              this.children = [...this.children, ...new Array(newVal-oldVal).fill(null)]
          }
        },
        childrenAges: function (newVal, oldVal) {
            this.children = newVal
            if (Array.isArray(newVal)) this.numChildren = newVal.length
        },
        numAdults: function (newVal, oldVal) {
            this.adults = newVal
        },
        adults: function (newVal, oldVal) {
            this.$emit('unitChanged', {idx: this.idx, adults: newVal, children:this.children})
        },
        children: function (newVal, oldVal) {
            this.$emit('unitChanged', {idx: this.idx, adults: this.adults, children: newVal})
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Room.vue